import { apiService } from './api';

class DemoService {
  async resetDemoData(): Promise<{ status: string }> {
    return apiService.post<{ status: string }>('/demo/reset');
  }
}

export const demoService = new DemoService();
